<template>
  <div class="menu-page">
    <div class="menu-page-left">
      <SelectTree
        ref="myTree"
        :option="treeOption"
        @selectedTree="receiveData"
      />
    </div>
    <div class="menu-page-right">
      <div class="menu-page-view">
        <component
          :is="componentName"
          :record="record"
          :code="activeKey"
          :data="activeData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectTree from "@/components/dataTree/SelectTree";
import pages from "./pages/";

export default {
  name: "Maintenance",
  components: {
    ...pages,
    SelectTree
  },
  data() {
    return {
      component: "Base",
      record: "",
      activeKey: "",
      activeData: {
        treeSelect: "",
        specialMode: false
      },
      treeOption: {
        //URL数据请求地址
        api: "MaintenanceMenus_List",
        //数据字段
        dataField: "Data",
        //标题字段
        title: "Name",
        //子数组字段
        children: "Childs",
        //选择值字段
        keyValue: "Code",
        //使用模式
        checkMode: "childrenMode"
      }
    };
  },
  created() {},
  computed: {
    //组件判断函数
    componentName() {
      //如果能在导入文件index.js中找到对应名字，则启动对应页面
      if (pages[this.activeKey]) {
        return pages[this.activeKey];
      }
      //如果在导入文件index.js中找不到对应名字，则启动Base页面
      return "Base";
    }
  },
  methods: {
    //左测树每次选择时会激活此函数
    receiveData(Data) {
      //左测树反选时不会返回treeSelect，正选时传数据给组件
      if (Data.treeSelect) {
        this.activeKey = Data.treeSelect;
        this.activeData = Data;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.menu-page {
  width: 100%;
  display: flex;
  // height: calc(100vh - 180px);
  overflow: auto;

  &.mobile {
    display: block;

    .menu-page-left {
      border-right: unset;
      border-bottom: 1px solid #e8e8e8;
      width: 100%;
      height: 50px;
      overflow-x: auto;
      overflow-y: scroll;
    }
    .menu-page-right {
      padding: 20px 40px;
    }
  }

  .menu-page-left {
    border-right: 1px solid #e8e8e8;
    width: 224px;
    height: calc(100vh - 300px);
    // overflow: hidden;
    // overflow-y: auto;
  }

  .menu-page-right {
    flex: 1 1;
    padding: 0 40px;
    width: 100%;
    overflow: hidden;
    .menu-page-title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 12px;
    }
    .menu-page-view {
      padding-top: 12px;
    }
  }
}
</style>
